var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNoChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 37.5C56.25 39.5742 54.5742 41.25 52.5 41.25C50.4258 41.25 48.75 39.5742 48.75 37.5V11.25C48.75 9.1793 50.4258 7.5 52.5 7.5C54.5742 7.5 56.25 9.1793 56.25 11.25V37.5ZM33.75 37.5C33.75 39.5742 32.0742 41.25 30 41.25C27.9258 41.25 26.25 39.5742 26.25 37.5V18.75C26.25 16.6758 27.9258 15 30 15C32.0742 15 33.75 16.6758 33.75 18.75V37.5ZM22.5 37.5C22.5 39.5742 20.8242 41.25 18.75 41.25C16.6758 41.25 15 39.5742 15 37.5V30C15 27.9258 16.6758 26.25 18.75 26.25C20.8242 26.25 22.5 27.9258 22.5 30V37.5ZM41.25 22.5C43.3242 22.5 45 24.1758 45 26.25V37.5C45 39.5742 43.3242 41.25 41.25 41.25C39.1758 41.25 37.5 39.5742 37.5 37.5V26.25C37.5 24.1758 39.1758 22.5 41.25 22.5Z",
    fill: "#D0D3DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.75 3.75C5.8207 3.75 7.5 5.4293 7.5 7.5V46.875C7.5 47.9062 8.33906 48.75 9.375 48.75H56.25C58.3242 48.75 60 50.4258 60 52.5C60 54.5742 58.3242 56.25 56.25 56.25H9.375C4.19766 56.25 0 52.0547 0 46.875V7.5C0 5.4293 1.6793 3.75 3.75 3.75Z",
    fill: "#D0D3DA"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNoChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-chart.3197c40ee8c7453415f2fbcbe50cd5c4.svg";